import React from "react";
import { Link } from "react-router";
import connectToStores from "alt-utils/lib/connectToStores";
import {
  FlatButton,
  RaisedButton,
  IconMenu,
  MenuItem,
  IconButton
} from "material-ui";
import moment from "moment-timezone";
import BaseOverlay from "../overlays/base.jsx";
import InjectedTenantHTML from "./injected-tenant-html.jsx";
import { formatPrice, formatInsertables } from "../../util";
import { lighten } from "material-ui/utils/colorManipulator";

import WishlistStore from "../../stores/WishlistStore";
import StarButton from "./star-button.jsx";
import AppUtil from "../../utils/AppUtil.js";

class FilmButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuRevealed: false
    };

    this._makeButton = this._makeButton.bind(this);
    this._makeMenu = this._makeMenu.bind(this);

    this.getStyles = this.getStyles.bind(this);

    this.onEventSelect = this.onEventSelect.bind(this);
  }

  static get contextTypes() {
    return {
      isLarge: React.PropTypes.bool,
      isEmbed: React.PropTypes.bool,
      router: React.PropTypes.object.isRequired,
      tenant: React.PropTypes.object,
      appSettings: React.PropTypes.object,
      muiTheme: React.PropTypes.object
    };
  }

  static getStores() {
    return [WishlistStore];
  }

  static getPropsFromStores() {
    return {
      isWishlisted: WishlistStore.isWishlisted
    };
  }

  _makeButton(initialProps) {
    let styles = this.getStyles(),
      { style, ...props } = initialProps,
      buttonStyle = Object.assign({}, styles.button, style);

    if (this.props.events.length === 0) {
      return (
        <RaisedButton
          style={buttonStyle}
          {...props}
          label="No showings scheduled"
          disabled={true}
        />
      );
    }

    return this._makeMenu(
      <RaisedButton
        style={buttonStyle}
        {...props}
        onClick={e => {
          e.stopPropagation();
          e.preventDefault();
        }}
      />
    );
  }

  _makeMenu(iconButtonElement) {
    let styles = this.getStyles(),
      hasMultipleVirtualScreenings =
        this.props.events.filter(e => e.is_virtual).length > 1,
      items = this.props.events.map(event => {
        return (
          <MenuItem
            key={event.id}
            onClick={
              !event.is_virtual
                ? this.onEventSelect.bind(this, event)
                : undefined
            }
            style={Object.assign({}, styles.menuItem)}
            containerElement={
              event.is_virtual ? (
                <a
                  href={`${this.context.appSettings.urls.virtual_festival}/play/${event.id}`}
                  target="_blank"
                />
              ) : undefined
            }
            primaryText={
              event.is_virtual
                ? `${
                    event.is_dated &&
                    (moment(event.start_time) > Date.now() ||
                      moment(event.end_time) < Date.now())
                      ? `[Available ${
                          moment(event.start_time).twix(event.end_time).format({
                            monthFormat: "MMMM",
                            implicitDate: false,
                            implicitYear: false,
                            implicitMinutes: false
                          }) || "now"
                        }] `
                      : ""
                  }Stream online${
                    hasMultipleVirtualScreenings ? ` (${event.name})` : ""
                  }...`
                : `${moment(event.start_time).format("ddd, MMM Do, h:mm A")} ${
                    event.venue.name ? `@ ${event.venue.name}` : ""
                  }${
                    !event.tickets_available && event.ticket_buckets.length
                      ? ` (${this.context.tenant.event_sold_out_button_label.toUpperCase()})`
                      : ""
                  }`
            }
          />
        );
      });

    return (
      <div>
        {!AppUtil.isSundanceMobileMode(this.context.tenant) ? (
          <StarButton
            wishlisted={this.props.isWishlisted({
              type: "films",
              id: this.props.filmId
            })}
            type="films"
            id={this.props.filmId}
          />
        ) : null}
        <IconMenu
          iconButtonElement={iconButtonElement}
          menuStyle={styles.menu}
          desktop={true}
          autoWidth={true}
          useLayerForClickAway={true}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          targetOrigin={{ vertical: "top", horizontal: "right" }}
        >
          {items}
        </IconMenu>
      </div>
    );
  }

  onEventSelect(event, e) {
    this.context.router.push({
      pathname: `/schedule/${event.id}`,
      state: { from: "film" }
    });
    e.stopPropagation();
    e.preventDefault();
  }

  getStyles() {
    return {
      button: {},
      multiContainer: this.props.noMultiContainer
        ? {}
        : {
            //width: this.props.inline ? null : 380,
            textAlign: this.props.inline ? null : "right",
            float: !this.props.inline ? "right" : null,
            marginLeft: !this.props.inline ? 10 : null,
            marginBottom: !this.props.inline ? 10 : null
          },
      multiContainerSmall: {
        width: "100%",
        textAlign: "center",
        boxSizing: "border-box",
        padding: 6,
        paddingBottom: 20,
        borderBottom: "1px solid #ccc",
        marginBottom: 20
      },
      menu: {
        width: 400,
        maxWidth: "60vw",
        textAlign: "left"
      },
      menuItem: {
        cursor: "pointer",
        whiteSpace: "inherit",
        lineHeight: "25px",
        minHeight: "inherit",
        paddingTop: 4,
        paddingBottom: 4
      }
    };
  }

  render() {
    let styles = this.getStyles(),
      { event, compact, inline, hideButton } = this.props,
      isLarge = this.context.isLarge,
      Button = compact
        ? FlatButton
        : inline || !isLarge
        ? RaisedButton
        : FlatButton;

    let content,
      label = "Select a showing";

    if (hideButton) {
      content = [];
    } else {
      content = [this._makeButton({ label: label, primary: true })];
    }

    return (
      <div
        style={
          !isLarge && !compact && !inline
            ? styles.multiContainerSmall
            : styles.multiContainer
        }
      >
        {content}
      </div>
    );
  }
}

export default connectToStores(FilmButton);



// WEBPACK FOOTER //
// ./src/app/components/partials/film-button.jsx